import { useMemo } from 'react';
import Helmet from '../lib/Helmet';
import { CATALOGUE } from '../data/catalogue';
import { PRICES, STOCK } from '../data/pricing';
import { SERIES } from '../data/highlights';
import { usedSources } from '../data/guideInverter';
import { HEAT_SEO, HEAT_UPDATED, HEAT_SOURCES, SIZES, heatPair, heatContent } from '../data/guideHeat';
import { GuideHeader, GuideBody } from '../components/guide/GuideParts';
import HeatFlow from '../components/guide/HeatFlow';

// Route: /blog/hot-and-cold-ac — AC guide 9 (1 Nov 2026), in the new layout.
// Every word comes from heatContent() in data/guideHeat.js (Saheb's answers
// of 31 Oct 2026, Daikin, NDMA and IMD), which scripts/guide-pages.js reads too.

export default function HeatGuide() {
  const { c, S } = useMemo(() => {
    const pairs = SIZES.map((size) => heatPair({ catalogue: CATALOGUE, prices: PRICES, stock: STOCK, series: SERIES, size })).filter(Boolean);
    const content = heatContent(pairs);
    return { c: content, S: usedSources(HEAT_SOURCES, content) };
  }, []);

  return (
    <>
      <Helmet>
        <title>{HEAT_SEO.title}</title>
        <meta name="description" content={HEAT_SEO.meta} />
        <meta property="og:title" content={HEAT_SEO.title} />
        <meta property="og:description" content={HEAT_SEO.meta} />
      </Helmet>
      <main className="bg-white pb-16 pt-16 lg:pt-20">
        <article className="mx-auto max-w-[760px] px-4 text-base leading-relaxed text-gray-900">
          <GuideHeader seo={HEAT_SEO} updated={HEAT_UPDATED} crumb={HEAT_SEO.crumb} />
          <GuideBody c={c} sources={S} current="hot-and-cold-ac" ctaSource="guide_heat"
            ctaTitle="Want one AC for summer and winter?"
            watch={<HeatFlow watch={c.watch} sources={S} />} />
        </article>
      </main>
    </>
  );
}
